import { render, staticRenderFns } from "./SearchSupplierDashboard.vue?vue&type=template&id=3d211d3c&scoped=true&lang=pug&"
import script from "./SearchSupplierDashboard.vue?vue&type=script&lang=ts&"
export * from "./SearchSupplierDashboard.vue?vue&type=script&lang=ts&"
import style0 from "./SearchSupplierDashboard.vue?vue&type=style&index=0&id=3d211d3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d211d3c",
  null
  
)

export default component.exports